import { Col, Row, Spin } from "antd";
import React, { useState, useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import { o_pt_E } from "./option";
import { get_pt_envelope } from "@/services/propsApi";

// caslist:any, T: any,VF:any=0,method:any="SRK",npoints:any=20

const Component = (props: any) => {
  const { dataSource, loading } = props;

  return (
    <>
      {loading ? (
        <div className="loadingArea">
          <Spin />
        </div>
      ) : (
        <ReactEcharts
          option={o_pt_E(dataSource)}
          notMerge={true}
          lazyUpdate={true}
          style={{ height: "35rem", width: "100%" }}
        />
      )}
    </>
  );
};

export default Component;
